
export { GGUSection } from "/codebuild/output/src1412605272/src/packages/shared-components/src/campaign/GGUSection.tsx"